import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { fetchPortfolioData } from "./redux/portfolioSlice";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import GameZone from "./pages/GameZone";
import MyWork from "./pages/MyWork";
import AI from "./pages/AI";
import ContactMe from "./pages/ContactMe";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPortfolioData());
  }, [dispatch]);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/game-zone" element={<GameZone />} />
        <Route path="/my-work" element={<MyWork />} />
        <Route path="/ai" element={<AI />} />
        <Route path="/contact" element={<ContactMe />} />
      </Route>
    </Routes>
  );
}

export default App;